/** @format */
import { InstanceItem } from '../constants'

// 已选实例组件的props
export interface SelectedInstanceTabProps {
  className?: string
  selectedInstance: InstanceItem[]
  setSelectedInstance: (value: InstanceItem[]) => void
}

// CDN需要过滤的实例名称
export const needDrop = ['CDN_Web', 'CDN_File', 'CDN_Live', 'CDN_Video', 'CDN_All']

// 有层级的产品线
export const productObj = {
  29: {
    topType: 28,
    subTitle: '集群',
    shardTitle: 'Namespace',
    productType: 28
  },
  45: {
    topType: 28,
    subTitle: '集群',
    shardTitle: 'Namespace',
    productType: 28
  },
  68: {
    topType: 67,
    subTitle: '实例',
    productType: 66
  },
  49: {
    topType: 48,
    subTitle: '实例',
    productType: 12
  },
  75: {
    topType: 73,
    subTitle: '集群',
    productType: 72
  },
  82: {
    topType: 81,
    subTitle: '实例',
    productType: 80
  },
  71: {
    topType: 70,
    subTitle: '容器实例',
    productType: 69
  },
  85: {
    topType: 84,
    subTitle: '集群',
    productType: 83
  },
  86: {
    topType: 84,
    subTitle: '集群',
    productType: 83
  },
  51: {
    topType: 50,
    subTitle: '集群',
    productType: 13
  },
  53: {
    topType: 50,
    subTitle: '集群',
    shardId: 52,
    shardTitle: '分片',
    productType: 13
  },
  57: {
    topType: 56,
    subTitle: '副本集',
    productType: 13
  },
  98: {
    topType: 97,
    subTitle: '实例',
    productType: 97
  },
  100: {
    topType: 99,
    subTitle: '实例',
    productType: 99
  },
  101: {
    topType: 99,
    subTitle: '实例',
    productType: 99
  },
  103: {
    topType: 99,
    subTitle: '实例',
    productType: 99
  },
  106: {
    topType: 109,
    subTitle: '实例',
    productType: 106
  },
  120: {
    topType: 96,
    subTitle: '实例',
    productType: 120
  },
  121: {
    topType: 96,
    subTitle: '实例',
    productType: 121
  },
  122: {
    topType: 96,
    subTitle: '实例',
    productType: 122
  },
  123: {
    topType: 96,
    subTitle: '实例',
    productType: 123
  },
  124: {
    topType: 96,
    subTitle: '实例',
    productType: 124
  },
  139: {
    topType: 131,
    shardId: 139,
    subTitle: '独享型LB实例',
    productType: 131
  },
  140: {
    topType: 131,
    shardId: 140,
    subTitle: '独享型LB实例',
    productType: 131
  },
  141: {
    topType: 131,
    shardId: 141,
    subTitle: '独享型LB实例',
    productType: 131
  },
  166: {
    topType: 165,
    subTitle: '集群',
    productType: 165
  },
  168: {
    topType: 165,
    subTitle: '集群',
    shardId: 167,
    shardTitle: '分片',
    productType: 168
  },
  170: {
    topType: 169,
    subTitle: '副本集',
    productType: 169
  },
  179: {
    topType: 177,
    subTitle: '集群',
    shardId: 178,
    shardTitle: '分片',
    productType: 177
  }
}
// 容器POD
export const podOptions = ['Deployment', 'DaemonSet', 'StatefulSet', 'Job', 'CronJob']
